// Use `as const` instead of if you don't need any TS enum features
// prettier-ignore
export const BASE_ROUTES = {
  AGENCY: '/agency',
  AGENCY_ADMIN: '/agency-admin',
  COMPANY_ADMIN: '/company-admin',
  CREATE_AGENCY: '/create-agency',
  CREATE_ACCOUNT_PORTAL: '/create-account-portal',
  CREATE_COMPANY: '/create-company',
  DEV_GUIDE: '/dev',
  FORGOT_PASSWORD: '/forgot-password',
  NO_MATCH: '*',
  NOT_AUTHORIZED: '/404',
  UNAUTHORIZED: '/unauthorized',
  PASSWORD_RESET: '/password-reset',
  PASSWORD_CONFIRMATION: '/password-confirmation',
  PLATFORM_ADMIN: '/platform-admin',
  PROFILE: '/profile',
  REGISTRATION: '/registration',
  REGISTRATION_SUCCESS: '/create-company/success',
  REQUEST_RESET: '/request-reset',
  ROLE_SELECT: '/role-select',
  ROOT: '/',
  SIGNIN: '/signin',
  SOCIAL_SIGNIN: '/social-signin',
  SOCIAL_SIGNUP: '/social-signup',
} as const

export const SIDEBAR_ROUTES = {
  ADD_ADMIN: '/add-admin',
  ADD_ORDER: '/manage-orders/add-order',
  ADD_POSITION: '/manage-positions/add-position',
  ADD_TEMPLATE: '/manage-templates/add-template',
  CANDIDATES: '/candidates',
  COMPANY_CANDIDATE_LIST: '/manage-orders/candidate-list',
  CLIENT_POSITIONS: '/client-positions',
  COMPLETED_SERVICE_ORDERS: '/manage-orders/completedOrders',
  DASHBOARD: '/dashboard',
  DATA_CLEANUP: '/data-cleanup/:cardId',
  DATA_CLEANUP_BASE: '/data-cleanup',
  EDIT_ADMIN: '/edit-admin',
  EDIT_POSITION: '/manage-positions/edit-position',
  EDIT_SERVICEORDER: '/manage-orders/edit-service-order',
  EDIT_TEMPLATE: '/manage-templates/edit-template',
  FILES: '/files',
  GENERAL_USERS: '/general-users',
  GENERAL_ADMINS: '/general-admins',
  IMPORT: '/import',
  DATA_MIGRATION: '/data-migration',
  JOB_ORDERS: '/manage-job-orders',
  JOB_ORDER_DETAILS: '/manage-job-orders/:orderId',
  JOB_ORDER_DETAILS_SUMMARY: '/manage-job-orders/summary',
  MAIL: '/mail',
  MANAGE_AGENCY: '/manage-agency',
  MANAGE_AGENCIES: '/manage-agencies',
  MANAGE_COMPANY: '/manage-company',
  MANAGE_COMPANIES: '/manage-companies',
  MANAGE_COMPANIES_DETAILS: '/manage-companies/:companyName',
  MANAGE_MSP_AGENCY: '/manage-msp-agency',
  MANAGE_PROFILE: '/manage-profile',
  MANAGE_TEMPLATES: '/manage-templates',
  REQUISITION_TEMPLATE: '/requisition-template',
  REPORTS: '/reports',
  MODULES: '/modules',
  ONBOARDING_AGENCY: '/onboarding-agency',
  ONBOARDING_COMPANY: '/onboarding-company',
  PENDING_SERVICE_ORDERS: '/manage-orders/pending',
  POSITIONS: '/manage-positions',
  PREFILL: '/prefill/:prefillCardId',
  PREFILL_ADD: '/prefill-add',
  PREFILL_EDIT: '/prefill-edit',
  PREFILL_JOB_ORDER: '/jobOrderPrefill',
  SERVICE_ORDERS: '/manage-orders',
  SERVICE_ORDER_DETAILS: '/manage-orders/:orderId',
  SERVICE_ORDER_PENDING_DETAILS: '/manage-orders/pending/:serviceOrderId',
  SERVICE_ORDER_DETAILS_SUMMARY: '/manage-orders/summary',
  SERVICE_ORDER_CANDIDATE_DISTRIBUTION: '/manage-orders/candidate-distribution',
  TEMPLATE_DETAILS: '/manage-templates-details/',
  USERS_AND_ROLES: '/users-and-roles',
  // Global Navigation Routes
  GLOBAL: '/global',
  GLOBAL_METRICS: '/global/metrics',
  GLOBAL_COMPENSATION_CODES: '/global/compensation-codes',
  GLOBAL_WC_CATALOGS: '/global/wc-catalogs',
  GLOBAL_WC_CATALOG_COMPENSATION_CODES: '/global/wc-catalogs/compensation-codes/:catalogId',
  GLOBAL_ACTIVITY_LOG: '/global/activity-log',
  GLOBAL_PAYCODES: '/global/paycodes',
  GLOBAL_AUTHORITIES: '/global/authorities',
  GLOBAL_TAX: '/global/tax',
  // Payroll Management Route
  PAYROLL: '/payroll',
  // Agency Management Routes
  MANAGE_AGENCIES_NEW: '/manage-agencies/new',
  MANAGE_AGENCY_DETAIL: '/manage-agencies/:agencyId',
  MANAGE_AGENCY_PROFILE: '/manage-agencies/:agencyId/profile',
  MANAGE_AGENCY_CATALOGS: '/manage-agencies/:agencyId/catalogs',
  MANAGE_AGENCY_USERS_ROLES: '/manage-agencies/:agencyId/users-roles',
  MANAGE_AGENCY_ORDERS: '/manage-agencies/:agencyId/orders',
  MANAGE_AGENCY_DOCUMENTS: '/manage-agencies/:agencyId/documents',
  MANAGE_AGENCY_AFFILIATES: '/manage-agencies/:agencyId/affiliates',
  // Company Management Routes
  MANAGE_COMPANIES_NEW: '/manage-companies/new',
  MANAGE_COMPANY_DETAIL: '/manage-companies/:companyId',
  MANAGE_COMPANY_PROFILE: '/manage-companies/:companyId/profile',
  MANAGE_COMPANY_BILL_CODES: '/manage-companies/:companyId/bill-codes',
  MANAGE_COMPANY_BILL_CODES_ADD: '/manage-companies/:companyId/bill-codes/add',
  MANAGE_COMPANY_BILL_CODES_EDIT: '/manage-companies/:companyId/bill-codes/edit/:billCodeId',
  MANAGE_COMPANY_POSITIONS: '/manage-companies/:companyId/positions',
  MANAGE_COMPANY_USERS_ROLES: '/manage-companies/:companyId/users-roles',
  MANAGE_COMPANY_ORDERS: '/manage-companies/:companyId/orders',
  MANAGE_COMPANY_DOCUMENTS: '/manage-companies/:companyId/documents',
  // Region Management Routes
  MANAGE_REGION_DETAIL: '/manage-companies/:companyId/regions/:regionId',
  MANAGE_REGION_PROFILE: '/manage-companies/:companyId/regions/:regionId/profile',
  MANAGE_REGION_BILL_CODES: '/manage-companies/:companyId/regions/:regionId/bill-codes',
  MANAGE_REGION_DOCUMENTS: '/manage-companies/:companyId/regions/:regionId/documents',
  MANAGE_REGION_CREATE: '/manage-companies/:companyId/regions/create',
  // Site Management Routes
  MANAGE_SITE_DETAIL: '/manage-companies/:companyId/regions/:regionId/sites/:siteId',
  MANAGE_SITE_PROFILE: '/manage-companies/:companyId/regions/:regionId/sites/:siteId/profile',
  MANAGE_SITE_BILL_CODES: '/manage-companies/:companyId/regions/:regionId/sites/:siteId/bill-codes',
  MANAGE_SITE_DEPARTMENTS:
    '/manage-companies/:companyId/regions/:regionId/sites/:siteId/departments',
  MANAGE_SITE_POSITIONS: '/manage-companies/:companyId/regions/:regionId/sites/:siteId/positions',
  MANAGE_SITE_DOCUMENTS: '/manage-companies/:companyId/regions/:regionId/sites/:siteId/documents',
  MANAGE_SITE_CREATE: '/manage-companies/:companyId/regions/:regionId/sites/create',
  MANAGE_COMPANY_POSITION_TEMPLATE_NEW: '/manage-companies/:companyId/positions/templates/new',
  MANAGE_COMPANY_POSITION_NEW: '/manage-companies/:companyId/positions/new',
  // Agency Branch Management Routes
  ADD_NEW_BRANCH: '/manage-agencies/:agencyId/branches/new',
} as const
